import {Dialog, Grid, TextField} from "@material-ui/core";
import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import * as React from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {TagService} from "./TagService";

const TagInformation = ({openModal, handleClose, tagId, changeNeedRefreshState}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new TagService(fundID, token, snackbar, loading)

    const [tagName, setTagName] = useState("");

    useEffect(() => {
        if (tagId && tagId >= 0) {
            loading(setLoadingStateDispatch(true))
            service.getTAgInfo(tagId)
                .then(response => {
                    setTagName(response.name)
                    loading(setLoadingStateDispatch(false))
                }).catch(reason => {
                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت جزئیات تگ!"))
            })
        }
    }, [tagId])


    function doChange() {
        if (tagName && tagName.length > 0) {
            changeNeedRefreshState(true)
            if (tagId === -1) {
                service.addNewTag(tagName, clearFields)
            } else {
                service.updateTag(tagId, tagName)
            }
        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا نام تگ را وارد نمایید."))
        }
    }

    useEffect(() => {
        if (!openModal)
            clearFields()
    }, [openModal])

    function clearFields() {
        setTagName("")
    }

    function doDelete() {
        changeNeedRefreshState(true)
        loading(setLoadingStateDispatch(true))
        service.deleteTag(tagId)
            .then(response => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "تگ با موفقیت حذف شد."))
                loading(setLoadingStateDispatch(false))
                handleClose()
            }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در حذف تگ!"))
            loading(setLoadingStateDispatch(false))
        })
    }

    return (
        <Dialog open={openModal} onClose={handleClose}>
            <section
                className={css`
                  padding: 16px;
                  display: flex;
                  flex-direction: column;
                `}>
                <span>{tagId === -1 ? "افزودن تگ جدید" : "ویرایش تگ"}</span>
                <Grid sm={12} md={12} lg={12} xl={12} className={css`margin-top: 16px;`}>
                    <TextField className='w-100' variant="outlined" label="نام"
                               value={tagName}
                               onChange={e => {
                                   setTagName(e.target.value)
                               }}/>
                </Grid>

                <div className={css`display: flex;
                  flex-wrap: nowrap;
                  width: 100%;
                  margin-top: 16px;
                  gap: 8px;

                  & > button {
                    flex-grow: 1;
                  }
                `}>
                    <button
                        onClick={doDelete}
                        className={`${tagId === -1 ? "d-none" : "btn-secondary flex-grow-1"}`}>
                        حذف
                    </button>
                    <button
                        onClick={doChange}
                        className={`btn-confirm flex-grow-1`}>
                        {tagId === -1 ? "افزودن" : "بروزرسانی"}
                    </button>
                </div>
            </section>
        </Dialog>
    )
}

export default TagInformation;